module.exports = __webpack_public_path__ + "static/media/ico_phone_one.ebb2e0fc.svg";